import clsx from "clsx";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import { PlanStatusActive } from "@/common/enums/enums";

interface PlanStatusBadgeProps {
  status: string;
}

export default function PlanStatusBadge(
  props: PlanStatusBadgeProps,
): JSX.Element {
  const { t } = useTranslation();
  const statusLabel: Record<string, string> = {
    [PlanStatusActive.ACTIVE]: t("settings.subscription.status.active"),
    [PlanStatusActive.CANCELLED]: t("settings.subscription.status.cancelled"),
  };
  const statusStyle: Record<string, string> = {
    [PlanStatusActive.ACTIVE]: "text-white bg-success",
    [PlanStatusActive.CANCELLED]: "text-white bg-error",
  };

  return (
    <span
      className={clsx(
        "text-xs px-3 py-1 rounded-full border font-medium",
        statusStyle[props.status] ?? "text-grey-600 bg-grey-100",
      )}
    >
      {statusLabel[props.status] ?? props.status}
    </span>
  );
}
